module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"party_dates":["Meet&Greet, Bondage, SM & Spank","Play&Pampers","Frechdax&Wiesn"]}}')
  delete Component.options._Ctor
}
